<div class="container-fluid" *ngIf="user.role=='superadmin'">
    <!-- add admin documents -->
    <div class="input-container" id="Check4">
      <label for="myCheck4">Afficher le formulaire d'ajout de document</label>
      <input type="checkbox" id="myCheck4" (click)="myFunction4()">
    </div>
    <div id="bodycontainer4">
      <div class="container-fluid"> 
        <fieldset>
          <div class="form-group row">
            <label class="col-sm-12 col-form-label"> Charger document</label>
            <div class="col-sm-12">
              <input type="text"placeholder='titre du document' class="form-control"[(ngModel)]="title">
            </div>
            <div class="col-sm-12">
              <textarea name="" id="" cols="30" rows="2"placeholder='insérer commentaire'class="form-control"[(ngModel)]="comm"></textarea>
            </div>
              <div class="col-sm-12">
                <input type="file"  class="form-control inputFile" accept="application/pdf"(change)="onImagePick($event)">
              </div>
              <div class="col-sm-12 mt-3">
                <label class="form-label">Types de profil</label>
                <div *ngFor="let type of userTypes">
                  <input type="checkbox" [id]="type.value" [(ngModel)]="type.selected" name="userTypes">
                  <label [for]="type.value">{{ type.label }}</label>
                </div>
              </div>
          </div>
          <button class="btn btn-success" (click)="afficher4()"> <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>Valider</button>
        </fieldset>
      <p>{{ errormsg }}</p>
    </div>
    </div>
  <!-- add multiple users -->
  <div class="input-container" id="Check2">
    <label for="myCheck1">Afficher le formulaire d'ajouts d'utilisateurs</label>
    <input type="checkbox" id="myCheck2" (click)="myFunction2()">
  </div>
  <div id="bodycontainer2">
    <div class="container-fluid"> 
      <fieldset>
        <legend> Insérer plusieurs utlisateurs   &nbsp;&nbsp;&nbsp; <a href="https://macompta.com.tn:3000/ptr/create-users.xlsx"target="_blank">Charger structure fichier</a> </legend>
        <div class="form-group row">
          <label class="col-sm-12 col-form-label"> Charger document</label>
            <div class="col-sm-12">
              <input type="file"  class="form-control inputFile" accept=".xls, .xlsx"(change)="onFileChange($event);">
            </div>
        </div>
        <button class="btn btn-success" (click)="afficher()"> <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>Valider</button>
      </fieldset>
    <p>{{ errormsg }}</p>   
  </div>
  </div>
 <!--add habilitations--> 
  <div class="input-container" id="Check3">
    <label for="myCheck3">Afficher le formulaire d'ajouts des habilitations</label>
    <input type="checkbox" id="myCheck3" (click)="myFunction3()">
  </div>
  <div id="bodycontainer3">
    <div class="container-fluid"> 
        <fieldset >
         <legend>Habilitations</legend>
         <table class="table table-striped" id="factureachatsection" [formGroup]="habilitationform"*ngIf="habilitations">
<thead *ngIf="habilitations.length>0">
  <tr>
    <th>ID</th>
    <th>intitulé</th>
    <th>Date de création</th>
    <th>Date de modification</th>
  </tr>
</thead>
<tbody *ngIf="habilitations.length>0">
  <tr *ngFor="let item of habilitations; let i = index;">  
    <td  style="text-align: center;width: 50px;"> {{item.id}}</td>     
    <td  style="text-align: center;">{{item.intitule| lowercase}}</td>
    <td  style="text-align: center;"> {{item.created | customDate}}</td>
    <td  style="text-align: center;"> {{item.updated | customDate}}</td>
    <td colspan="5">
      <div>
      <button type="button" class="btn btn-danger btn-sm" (click)="onDelete(item._id)"><span><i class="fa fa-minus-circle"></i></span></button>   
    </div>
</td>     
  </tr>
</tbody>
<thead>
  <tr>
    <th>ID</th>
    <th>intitulé</th>
  </tr>
</thead>
<tbody formArrayName="ammounts">
<tr *ngFor="let ammount of ammountControls; let i = index;"[formGroupName]="i">
<td>
<input type="text"class="form-control"  formControlName="id" placeholder="ID"/>
</td>
<td>
  <div class="col-6">
<input type="text"class="form-control"  formControlName="intitule" placeholder="intitulé"/>
</div>
</td>
<td>
  <button type="button" class="btn btn-danger btn-sm" (click)="removeammount(i)"><span><i class="fa fa-minus-circle"></i></span></button>
</td>
</tr>
<tr>
  <td colspan="2"> 
    <button type="button" class="btn btn-success btn-sm" (click)="addammount()"><span><i class="fa fa-plus-circle"></i></span></button>
  </td>
</tr>
</tbody>
        </table>
<button class="btn btn-primary btn-sm" (click)="savehabilitation()"><i class="fa fa-refresh fa-spin"*ngIf="loading"></i>Sauvegarder</button>
</fieldset> 
  </div>
  </div> 
</div>
  <!--generate chargebacks-->
<button (click)="generatechargeback()" [disabled]="isLoading"*ngIf="user.role=='adminbanque'&&user.usertype=='Metier'">
  <ng-container *ngIf="!isLoading; else loading">
      Generate Out
  </ng-container>
  <ng-template #loading>
      <span class="loader"></span> Generating...
  </ng-template>
</button>